import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { NgbModal, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, CmsService, GlobalMessageService, GlobalMessageType, OccEndpointsService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import * as FileSaver from 'file-saver';
import * as lod from 'lodash';
import moment from "moment";
import { forkJoin, Subject, Subscription } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { GeneralPopupComponent } from "src/app/shared/modules/general-popup/general-popup/general-popup.component";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import * as XLSX from 'xlsx';
import { CustomInfluenzaService } from "../custom-influenza.service";
import { ProductDetailsInfluenzaComponent } from "../product-details-influenza/product-details-influenza.component";
import { CustomAuthService } from '../../custom-auth-service.service';

@Component({
    selector: 'app-sts-shipping-schedule',
    templateUrl: './sts-shipping-schedule.component.html',
    styleUrls: ['./sts-shipping-schedule.component.scss'],
    standalone: false
})
export class StsShippingScheduleComponent implements OnInit, OnDestroy {
  baseUrl: any;
  baseSiteId: any;
  header: any = 'StsShippingSchedule';
  isUpdated: boolean; //by default true, make it false if moving out of flu journey
  showUnits: boolean = true;

  activeSeasonId: any;
  deliveryDate: any = '';
  userData: any = [];
  parentCartId: any;
  reservationNo: string = '';      //to be blank initially -VO6735562
  reservationStatus: string = '';  //to be blank initially, values- Confirmed, Partially Confirmed, Not Confirmed
  editReservation: boolean = false;      //to be false initially
  cancelSts: boolean = false;
  @ViewChild('confirmModal') modalContent;
  @ViewChild('clearCalendarModal') clearCalendarContent;
  nextRouteUrl: any = '';
  notConfirmedMessage: string = '';

  headerMessage: any;
  programMessage: any;
  clearCalendarMessage = `You don't have any units in this reservation to schedule shipments. Please clear your calendar in order to update this reservation.`; //default value (configurable from backend)
  remainingUnits: number = 0;
  remainingDoses: number = 0;
  isCalendarViewOnly: boolean = false;
  isCalendarUpdated: boolean = false; //This will change based on calendar changes ( in case of any error in unit, it is to be made false)

  schedulerStatus: string = ''; //This will change based on calendar changes
  isSticky: boolean = false;
  isCartSticky: boolean = false;

  //subscriptions
  activeSeasonSubscriber: Subscription;
  userDataSub: Subscription;
  getCartsApiSubscriber: Subscription;
  fluTimerJourneySub: Subscription;
  navigationEndSub: Subscription;
  FluExtendSub: Subscription;
  authCheckSub: Subscription;
  shippingMainDataSub: Subscription
  shippingCalendarDataSub: Subscription
  fluTimer = 29 * 60 * 1000;  //29min
  selectedType: any;

  frequencyList: any;
  startDate: any;
  endDate: any;
  stsReservationList: any[];
  stsEnabledProducts: any = [];
  stsProductsJoinedList: any = [];//List of STS products to loop through and show on UI.
  weekData: any[];
  monthsList: any;
  weeksList: any = [];
  jointResponse: any;
  grouped_items: any;
  // showUpdateRow: boolean = false;
  public myMath = Math;
  updateFreqFlag: boolean = false;
  b2bunitID = '';

  isEditFlow: boolean = false;
  currentPopover: NgbPopover;
  thresholdError: boolean = false;
  editFreqSub: Subscription;
  saveStsSub: Subscription;
  private destroy$: Subject<void> = new Subject<void>();
  lockMessage: any;
  quickMessage: any;
  onsnUnits = 0;
  onsnDoses = 0;

  totalNegativeQtyCounter = 0;
  headerContent: any;
  programContent: any;
  quickContent: any;
  lockContent: any;
  shipDate: any;

  @HostListener('window:scroll', ['$event'])
  checkScroll(event) {
    if (window.pageYOffset >= 1100) {
      this.isCartSticky = true;
    } else {
      this.isCartSticky = false;
    }
  }

  constructor(
    private baseSiteService: BaseSiteService,
    private readonly ref: ChangeDetectorRef,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly modalService: NgbModal,
    private readonly router: RoutingService,
    private readonly sharedService: SharedService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly user: UserAccountFacade,
    private route: Router,
    private readonly addToCart: CustomAddToCartService,
    private readonly authService: CustomAuthService,
    private readonly sanitizer: DomSanitizer,
    private readonly occEndPoint: OccEndpointsService,
    private readonly globalMessage: GlobalMessageService,
    private readonly cmsData: CmsService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {
    this.isEditFlow = this.activatedRoute.snapshot.queryParams.editDoses ? true : false;
    this.jointResponse = this.sharedService.getSessionStorage('fluData');
    this.schedulerStatus = 'Remaining to schedule';
    this.isUpdated = true; //by default true when coming to this schedule page, since there were change in previous page.
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.setSeasonId();
    this.checkForEditReservation();
    this.checkNavigationAway();
    this.checkLogout();
    this.b2bunitID = this.getB2BUid();
    this.deliveryDate = this.activatedRoute.snapshot.queryParams.deliveryDate ? this.activatedRoute.snapshot.queryParams.deliveryDate : '';
    this.shipDate = this.activatedRoute.snapshot.queryParams.shippingDate ? this.activatedRoute.snapshot.queryParams.shippingDate : '';
    this.cmsData
      .getComponentData('FullCancelPopupSlotComponent')
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res) {
          this.clearCalendarMessage = res?.content;
          this.ref.detectChanges();
        }
      });
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userData = res;
        this.getCartsApi(this.userData.uid);
        this.ref.detectChanges();
        this.userDataSub?.unsubscribe();
      }
    });

  }

  sanitizeHtmlResponse(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  //Not used
  getShippingMainData(userId, cartId, seasonId, b2bUnitId) {
    this.shippingMainDataSub = this.influenzaService.getStsShippingMainSectionData(userId, cartId, seasonId, b2bUnitId).subscribe((res) => {
      if (res) {
        const headerContent = res?.headerMessage;
        this.headerMessage = this.sanitizeHtmlResponse(headerContent);
        const programContent = res?.programMessage;
        this.programMessage = this.sanitizeHtmlResponse(programContent);
        this.remainingUnits = res?.totUnits ? +res?.totUnits : 0;
        this.remainingDoses = res?.totDoses ? +res?.totDoses : 0;
        this.isCalendarViewOnly = res?.isCalenderLocked ? res?.isCalenderLocked : false;
        this.ref.detectChanges();
        this.shippingMainDataSub?.unsubscribe();
      }
    }, errors => {
      this.shippingMainDataSub?.unsubscribe();
    })

  }

  //Not used
  getShippingCalendarData(userId, cartId, seasonId, b2bUnitId) {
    this.shippingCalendarDataSub = this.influenzaService.getStsShippingCalendarSectionData(userId, cartId, seasonId, b2bUnitId).subscribe((res) => {
      if (res) {
        this.shippingCalendarDataSub?.unsubscribe();
      }
    }, errors => {
      this.shippingCalendarDataSub?.unsubscribe();
    });
  }

  getShippingCompleteData(userId, cartId, seasonId, b2bUnitId) {
    let getShippingMainData;
    let getShippingCalendarData;
    if (this.editReservation) {
      getShippingMainData = this.influenzaService.getOrderStsShippingMainSectionData(userId, cartId, seasonId, b2bUnitId, this.reservationNo);
      getShippingCalendarData = this.influenzaService.getOrderStsShippingCalendarSectionData(userId, cartId, seasonId, b2bUnitId, this.reservationNo);
    }
    else {
      getShippingMainData = this.influenzaService.getStsShippingMainSectionData(userId, cartId, seasonId, b2bUnitId);
      getShippingCalendarData = this.influenzaService.getStsShippingCalendarSectionData(userId, cartId, seasonId, b2bUnitId);
    }

    forkJoin([getShippingMainData, getShippingCalendarData])  //takes in array of observables
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {                            //emits array of responses in order once all apis completes in parallel.

        //1 main sectiond data:
        this.headerContent = res[0]?.headerMessage;
        this.headerMessage = this.sanitizeHtmlResponse(this.headerContent);
        this.programContent = res[0]?.programMessage;
        this.programMessage = this.sanitizeHtmlResponse(this.programContent);

        this.quickContent = res[0]?.quickPickMessage;
        this.quickMessage = this.sanitizeHtmlResponse(this.quickContent);

        this.isCalendarViewOnly = res[0]?.isCalenderLocked ? res[0]?.isCalenderLocked : false;
        this.lockContent = res[0]?.lockMessage;
        this.lockMessage = this.sanitizeHtmlResponse(this.lockContent);
        if (this.cancelSts && !this.isCalendarViewOnly) {
          this.showClearCalendarPopup();
        }



        this.ref.detectChanges();


        this.remainingUnits = res[1]?.totalSTSUnits ? +res[1]?.totalSTSUnits : 0;
        this.remainingDoses = res[1]?.totalSTSDoses ? +res[1]?.totalSTSDoses : 0;
        this.frequencyList = [];
        this.frequencyList = res[1]?.stsFrequency ? res[1]?.stsFrequency : this.getFrequencyDropdown();

        this.startDate = res[1]?.stsTierManagement?.startDate;
        this.endDate = res[1]?.stsTierManagement?.endDate;

        this.stsReservationList = res[1]?.fluStsMap?.reservationSTSData;
        this.stsEnabledProducts = res[1]?.stsEnabledProducts;

        // below variables for edit reservation case
        let totalNegativeQtyCounterForEdit = 0;
        let totalRemaingUnitsForEdit = 0;
        let totalRemaningDosesForEdit = 0;

        this.stsProductsJoinedList = this.stsReservationList?.map((stsPrdct, index) => {

          //Copying few attributes from 'select vaccine request'
          const matchedJoinedResp = this.jointResponse?.find(element => element?.code === stsPrdct?.materialNum);
          if (matchedJoinedResp) {
            stsPrdct['thumbNailImg'] = matchedJoinedResp?.thumbNailImg;
            stsPrdct['productQuantityValue'] = matchedJoinedResp?.productQuantityValue;
            stsPrdct['quantity'] = matchedJoinedResp?.productQuantityValue;

            if (matchedJoinedResp?.shipNow === "ON") {
              this.onsnUnits += matchedJoinedResp?.productQuantityValue;
              const onsnDosseCount = matchedJoinedResp?.productQuantityValue * matchedJoinedResp?.quantityPerUnit;
              this.onsnDoses += onsnDosseCount;
            }

            if (this.editReservation) {
              stsPrdct['partOfEarlierReservation'] = matchedJoinedResp?.partOfEarlierReservation;
              stsPrdct['originalProductQuantityValue'] = matchedJoinedResp?.originalProductQuantityValue;
              stsPrdct['quantityPerUnit'] = matchedJoinedResp?.quantityPerUnit;
            }
          }
          //prod frequency related
          stsPrdct['selectedFreq'] = undefined;
          stsPrdct['prevSelectedFreq'] = undefined;
          stsPrdct['freqChanged'] = false;
          stsPrdct['frequencyList'] = [...this.frequencyList];
          stsPrdct['prevFrequencyList'] = [...this.frequencyList];

          if (stsPrdct?.sameAsPreviousSeasonEnable) {
            const prevFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'sameaspreviousseason');
            if (!prevFreq) {
              stsPrdct?.frequencyList?.push({
                code: 'sameaspreviousseason',
                name: 'Same as last season'
              });
              stsPrdct?.prevFrequencyList?.push({
                code: 'sameaspreviousseason',
                name: 'Same as last season'
              });
            }
          }

          //Threshold error counter added
          stsPrdct['thresholdErrorCounter'] = 0;
          //Total units count for pdct
          stsPrdct['totalUnitsCount'] = 0
          //Added to create months list -to show accordions
          if (index === 0) {
            this.monthsList = [];
          }
          //Each product month
          stsPrdct?.materialSchedule?.map((item, indx) => {
            //month wise total of product
            item['totalMonthsUnitsCount'] = 0;

            // only from 1st product - we can create the months list
            if (index === 0) {

              if (item?.stsMonthYear && item?.stsMonthYear != null) {
                let obj = {};
                if (indx <= 2) {
                  obj['showUnits'] = true;
                }
                else {
                  obj['showUnits'] = false;
                }
                obj['monthyear'] = item?.stsMonthYear;
                obj['totalUnits'] = 0;
                obj['totalDoses'] = 0;
                this.monthsList.push(obj);

              }
            }



            if (this.editReservation && stsPrdct?.partOfEarlierReservation
              && !this.isEditFlow) {   //if edit doses -> then calculation can be done later using - stsRequestData

              item?.weekList?.map(week => {

                if (week?.finalQty > 0) {
                  item['totalMonthsUnitsCount'] += week?.finalQty;
                  stsPrdct['selectedFreq'] = week?.freqSelected;
                  stsPrdct['prevSelectedFreq'] = week?.freqSelected;

                  if(week?.freqSelected){
                    const resetFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'reset');
                    if (!resetFreq) {
                      stsPrdct?.frequencyList?.push({
                        code: 'reset',
                        name: 'Reset'
                      });
                    }
                  }
                }
              });

              this.monthsList[indx].totalUnits += item['totalMonthsUnitsCount'];
              this.monthsList[indx].totalDoses = this.monthsList[indx].totalUnits * stsPrdct?.quantityPerUnit;
              stsPrdct['totalUnitsCount'] += item['totalMonthsUnitsCount'];
            }
          }); //product's materialSchedule(months) loop ends



          if (this.editReservation && !this.isEditFlow) {
            if (stsPrdct['totalUnitsCount'] > 0) {
              stsPrdct['quantity'] = stsPrdct['productQuantityValue'];
              stsPrdct['quantity'] = stsPrdct['quantity'] - stsPrdct['totalUnitsCount'];

              if (stsPrdct?.selectedFreq === undefined) {
                stsPrdct['prevFrequencyList'] = [...stsPrdct.frequencyList];
                stsPrdct['prevSelectedFreq'] = stsPrdct['selectedFreq'];

                const customFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'custom');
                if (!customFreq) {
                  stsPrdct?.frequencyList?.push({
                    code: 'custom',
                    name: 'Custom'
                  });
                }
                const resetFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'reset');
                if (!resetFreq) {
                  stsPrdct?.frequencyList?.push({
                    code: 'reset',
                    name: 'Reset'
                  });
                }
                stsPrdct['selectedFreq'] = 'custom';
              }
              else if (stsPrdct?.selectedFreq === 'custom') {
                const customFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'custom');
                if (!customFreq) {
                  stsPrdct?.frequencyList?.push({
                    code: 'custom',
                    name: 'Custom'
                  });
                }
                const resetFreq = stsPrdct?.frequencyList?.find(freq => freq.code === 'reset');
                if (!resetFreq) {
                  stsPrdct?.frequencyList?.push({
                    code: 'reset',
                    name: 'Reset'
                  });
                }
              }
            }
            //this code to be executed for both existing and new products
            totalRemaingUnitsForEdit += stsPrdct['quantity'];
            totalRemaningDosesForEdit += stsPrdct['quantity'] * stsPrdct.quantityPerUnit;
            //Updating counter as per each product qty
            if (stsPrdct['quantity'] < 0) {
              totalNegativeQtyCounterForEdit += 1;
            }
          }
          const matchedElement = this.stsEnabledProducts?.find(element => element?.code === stsPrdct?.materialNum);
          return {
            ...stsPrdct,
            ...matchedElement
          };
        }); //product loop ends

        this.stsProductsJoinedList = lod.sortBy(this.stsProductsJoinedList, ['baseProductName']); //in case of any issue due to sorting, just remove this line




        if (this.onsnUnits > 0) {
          this.stsProductsJoinedList = this.stsProductsJoinedList?.filter(element => element?.shipNow === "OFF");
          this.remainingUnits = this.remainingUnits - this.onsnUnits;
          this.remainingDoses = this.remainingDoses - this.onsnDoses;
          if (this.remainingUnits < 0) this.remainingUnits = 0;
          if (this.remainingDoses < 0) this.remainingDoses = 0;
        }

        //Edit reservation
        if (this.editReservation) {
          if (this.onsnUnits > 0) {
            totalRemaingUnitsForEdit = totalRemaingUnitsForEdit - this.onsnUnits;
            totalRemaningDosesForEdit = totalRemaningDosesForEdit - this.onsnDoses;
            if (totalRemaingUnitsForEdit < 0) totalRemaingUnitsForEdit = 0;
            if (totalRemaningDosesForEdit < 0) totalRemaningDosesForEdit = 0;
          }
          this.calcTotalAndStatusForEditReservation
            (totalNegativeQtyCounterForEdit,
              totalRemaingUnitsForEdit,
              totalRemaningDosesForEdit);
        }

        //New reservation - In case of EDIT DOSES
        if (!this.editReservation && this.isEditFlow) {
          // the above 2 get apis are still called as user may add a new product altogether while doing edit Doses:
          // Need to update the details as done in edit Frequency
          this.editStsDataForEditDoses();
        }
        this.ref.detectChanges();
      }, errors => {
        window.scrollTo(0, 0);
        this.globalMessage.add(errors.message,
          GlobalMessageType.MSG_TYPE_ERROR);
      }); //forkjoin ends
  }

  //called only in case of edit reservation - on landing of page
  calcTotalAndStatusForEditReservation(totalNegativeQtyCounter, totalRemaingUnits, totalRemaningDoses) {
    //passed parameters will be 0 for EDIT DOSES flow of Edit reservation, else whatever calculated above
    // In case of EDIT DOSES - need to calc units and everything from - stsRequestData
    this.totalNegativeQtyCounter = totalNegativeQtyCounter; //later added
    if (this.isEditFlow) {
      let stsPrevData = this.sharedService.getSessionStorage('stsRequestData');
      this.stsProductsJoinedList?.map(stsProd => {
        const matchedElement = stsPrevData?.find(entry => entry?.materialNum === stsProd?.materialNum);
        if (matchedElement) {
          stsProd['totalUnitsCount'] = 0;
          stsProd?.materialSchedule?.map(existingMaterial => {
            const matchedSchedule = matchedElement?.materialSchedule?.find(newMaterial => newMaterial?.stsMonthYear === existingMaterial?.stsMonthYear);
            if (matchedSchedule) {
              //below weeklist must be already sorted as getting from session
              existingMaterial.weekList = [...matchedSchedule?.weekList];
              existingMaterial.totalMonthsUnitsCount = 0;
              existingMaterial.weekList.map(week => {
                if (week.finalQty > 0) {
                  existingMaterial.totalMonthsUnitsCount += week?.finalQty;
                }
              });
              let matchedMonth = this.monthsList?.find(month => month.monthyear === existingMaterial?.stsMonthYear);
              if (matchedMonth) {
                matchedMonth.totalUnits += existingMaterial['totalMonthsUnitsCount'];
                matchedMonth.totalDoses = matchedMonth.totalUnits * stsProd['quantityPerUnit'];
              }
              stsProd['totalUnitsCount'] += existingMaterial['totalMonthsUnitsCount'];
            }
          });//materialSchedule loop ends
          if (stsProd['totalUnitsCount'] >= 0) {
            stsProd['quantity'] = stsProd['productQuantityValue'];
            stsProd['quantity'] = stsProd['quantity'] - stsProd['totalUnitsCount'];
          }
          //frequency related data copied
          stsProd['selectedFreq'] = matchedElement['selectedFreq'];
          stsProd['prevSelectedFreq'] = matchedElement['prevSelectedFreq'];
          stsProd['freqChanged'] = matchedElement['freqChanged'];
          stsProd['frequencyList'] = [...matchedElement.frequencyList];
          stsProd['prevFrequencyList'] = [...matchedElement.prevFrequencyList];
        }
        else {//For new products which are not part of edit doses - totalMonthsUnitsCount/totalUnitsCount remain 0 only
        }
        totalRemaingUnits += stsProd['quantity'];
        totalRemaningDoses += stsProd['quantity'] * stsProd.quantityPerUnit;
        //Updating counter as per each product qty
        if (stsProd['quantity'] < 0) {
          // totalNegativeQtyCounter +=1;
          this.totalNegativeQtyCounter += 1;
        }
      }); //product loop ends

    }
    //Below logic to be executed whether edit reservation normal flow or edit doses
    //case a - no product exceeding
    // if(totalNegativeQtyCounter === 0){
    if (this.totalNegativeQtyCounter === 0) {
      if (totalRemaingUnits === 0) { //all products scheduled
        this.schedulerStatus = 'All units and doses have been scheduled';
        this.remainingUnits = 0;
        this.remainingDoses = 0;
      }
      else if (totalRemaingUnits > 0) {
        this.schedulerStatus = 'Remaining to schedule';
        this.remainingUnits = totalRemaingUnits;
        this.remainingDoses = totalRemaningDoses;
      }
    }
    //case b - atleast 1 product exceeding
    else if (this.totalNegativeQtyCounter > 0) {
      this.schedulerStatus = 'Exceeds Total';
      totalRemaingUnits = 0;
      totalRemaningDoses = 0;
      this.stsProductsJoinedList?.map((product) => {
        if (product['quantity'] < 0) {
          totalRemaingUnits += product['quantity'];
          totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
        }
      });
      this.remainingUnits = totalRemaingUnits;
      this.remainingDoses = totalRemaningDoses;
    }
    else {

    }
    if (this.schedulerStatus === 'Exceeds Total') {
      this.isCalendarUpdated = false;
    }
    else {
      this.isCalendarUpdated = true;
    }
    this.ref.detectChanges();
  }

  editStsDataForEditDoses() {
    let stsPrevData = this.sharedService.getSessionStorage('stsRequestData');

    this.totalNegativeQtyCounter = 0;
    let totalRemaingUnits = 0;
    let totalRemaningDoses = 0;

    this.stsProductsJoinedList?.map(stsProd => {
      const matchedElement = stsPrevData?.find(entry => entry?.materialNum === stsProd?.materialNum);
      if (matchedElement) {
        stsProd['totalUnitsCount'] = 0;
        stsProd?.materialSchedule?.map(existingMaterial => {
          const matchedSchedule = matchedElement?.materialSchedule?.find(newMaterial => newMaterial?.stsMonthYear === existingMaterial?.stsMonthYear);
          if (matchedSchedule) {
            //below weeklist must be already sorted as getting from session
            existingMaterial.weekList = [...matchedSchedule?.weekList];
            existingMaterial.totalMonthsUnitsCount = 0;
            existingMaterial.weekList.map(week => {
              if (week.finalQty > 0) {
                existingMaterial.totalMonthsUnitsCount += week?.finalQty;
              }
            });
            let matchedMonth = this.monthsList?.find(month => month.monthyear === existingMaterial?.stsMonthYear);
            if (matchedMonth) {
              matchedMonth.totalUnits += existingMaterial['totalMonthsUnitsCount'];
              matchedMonth.totalDoses = matchedMonth.totalUnits * stsProd['quantityPerUnit'];
            }
            stsProd['totalUnitsCount'] += existingMaterial['totalMonthsUnitsCount'];
          }
        });//materialSchedule loop ends
        if (stsProd['totalUnitsCount'] >= 0) {
          stsProd['quantity'] = stsProd['productQuantityValue'];
          stsProd['quantity'] = stsProd['quantity'] - stsProd['totalUnitsCount'];
        }
        //frequency related data copied
        stsProd['selectedFreq'] = matchedElement['selectedFreq'];
        stsProd['prevSelectedFreq'] = matchedElement['prevSelectedFreq'];
        stsProd['freqChanged'] = matchedElement['freqChanged'];
        stsProd['frequencyList'] = [...matchedElement.frequencyList];
        stsProd['prevFrequencyList'] = [...matchedElement.prevFrequencyList];
      }
      else {//For new products which are not part of edit doses - totalMonthsUnitsCount/totalUnitsCount remain 0 only







      }
      totalRemaingUnits += stsProd['quantity'];
      totalRemaningDoses += stsProd['quantity'] * stsProd.quantityPerUnit;

      if (stsProd['quantity'] < 0) {

        this.totalNegativeQtyCounter += 1;
      }

    });//prod loop ends


    if (this.totalNegativeQtyCounter === 0) {
      if (totalRemaingUnits === 0) { //all products scheduled
        this.schedulerStatus = 'All units and doses have been scheduled';
        this.remainingUnits = 0;
        this.remainingDoses = 0;
      }
      else if (totalRemaingUnits > 0) {
        this.schedulerStatus = 'Remaining to schedule';
        this.remainingUnits = totalRemaingUnits;
        this.remainingDoses = totalRemaningDoses;
      }
    }
    //case b - atleast 1 product exceeding
    else if (this.totalNegativeQtyCounter > 0) {
      this.schedulerStatus = 'Exceeds Total';
      totalRemaingUnits = 0;
      totalRemaningDoses = 0;
      this.stsProductsJoinedList?.map((product) => {
        if (product['quantity'] < 0) {
          totalRemaingUnits += product['quantity'];
          totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
        }
      });
      this.remainingUnits = totalRemaingUnits;
      this.remainingDoses = totalRemaningDoses;
    }



    if (this.schedulerStatus === 'Exceeds Total') {
      this.isCalendarUpdated = false;
    }
    else {
      this.isCalendarUpdated = true;
    }

    this.ref.detectChanges();
  }

  performQuantityUpdation(event: any, productCode, weekList, weekIndex, monthIndex) {
    let inputValue = (event?.target as HTMLInputElement)?.value;
    const digitsRegex = /^\d+$/;



    if (inputValue === '') {
      inputValue = '0';
    }

    if (inputValue?.length > 1 && inputValue?.startsWith('0')) {
      inputValue = inputValue.replace(/^0+/, '');
      (event.target as HTMLInputElement).value = inputValue;
    }







    if (+inputValue >= 0) {

      this.totalNegativeQtyCounter = 0;
      let totalRemaingUnits = 0;
      let totalRemaningDoses = 0;



      this.monthsList[monthIndex].totalUnits = 0;
      this.monthsList[monthIndex].totalDoses = 0;

      this.stsProductsJoinedList?.map((product) => {
        if (product.materialNum === productCode) {

          //changing frequency for that product to custom and adding reset as option
          if (product?.selectedFreq !== 'custom') {
            const customFreq = product?.frequencyList?.find(freq => freq.code === 'custom');
            if (!customFreq) {
              product?.frequencyList?.push({
                code: 'custom',
                name: 'Custom'
              });
            }
            const resetFreq = product?.frequencyList?.find(freq => freq.code === 'reset');
            if (!resetFreq) {
              product?.frequencyList?.push({
                code: 'reset',
                name: 'Reset'
              });
            }
            product['selectedFreq'] = 'custom';
            product['prevSelectedFreq'] = product['selectedFreq'];
            product['prevFrequencyList'] = [...product.frequencyList];
            this.ref.detectChanges();
          }

          product['totalUnitsCount'] = 0;
          product?.materialSchedule?.map((item, index) => {
            item['monthThreshold'] = 0;
            item['totalMonthsUnitsCount'] = 0;
            item?.weekList?.map((week, indxx) => {
              if (index === monthIndex && indxx === weekIndex) {
                item['monthThreshold'] = week?.qtyThreshold; //month threshold set as per input week.
              }
              if (week?.finalQty > 0) {
                item['totalMonthsUnitsCount'] += week?.finalQty;
                week['freqSelected'] = 'custom';
              }
            });
            if (index === monthIndex) {
              this.monthsList[index].totalUnits += item['totalMonthsUnitsCount'];
              this.monthsList[index].totalDoses = this.monthsList[index].totalUnits * product?.quantityPerUnit;
            }
            product['totalUnitsCount'] += item['totalMonthsUnitsCount'];

            // Threshold check moved out of the 1st loop of materials and moved to 2nd loop as by the time 1st loop completes, totalUnits is not calculated and causes problem if user enters data from bottom to top
            //Threshold check for the month whose input is changed
            if (index === monthIndex) {
              // in case for the month, total units is more than threshold, show popover for the week which made the threshold going more if not 0
              //updating monthThreshold depending on total remaining for the product
              //remainingQtyForProduct - actual count - input count till now (but it may include the current value also, we would have to deduce the input value as well)
              let remainingQtyForProduct = product['productQuantityValue'] - (product['totalUnitsCount'] - item['totalMonthsUnitsCount']);
              if (remainingQtyForProduct < 0) {
                remainingQtyForProduct = 0;
              }

              if (remainingQtyForProduct < item['monthThreshold']) {
                item['monthThreshold'] = remainingQtyForProduct;
              }
              if (item['totalMonthsUnitsCount'] > item['monthThreshold']) {
                item?.weekList?.map((week, indxxx) => {
                  if (indxxx === weekIndex) {
                    let exceedsPopoverElement;
                    if (week?.finalQty > 0) {
                      if (!week['showpopover']) { //opening popover and increasing counter only popover not opened
                        week['showpopover'] = true;
                        week['thresholdError'] = true;

                        product['thresholdErrorCounter'] += 1;
                        exceedsPopoverElement = document.getElementById('exceedsPopoverOpen-' + product?.materialNum + '-' + monthIndex + '-' + weekIndex);
                        this.ref.detectChanges();
                      }
                    }
                    else { // qty for the week made 0 but still total count for month > threshold
                      if (week['showpopover']) {
                        week['showpopover'] = false;
                        week['thresholdError'] = false;
                        product['thresholdErrorCounter'] -= 1;
                        exceedsPopoverElement = document.getElementById('exceedsPopoverClose-' + product?.materialNum + '-' + monthIndex + '-' + weekIndex);
                        this.ref.detectChanges();
                      }
                    }
                    if (exceedsPopoverElement) {
                      exceedsPopoverElement.click(); //opens popover if count >0
                    }
                  }
                });
              }
              else { // in case for the month, total units is less than threshold, close all popovers which are opened for that month
                item?.weekList?.map((week, indx) => {
                  if (week['showpopover']) {
                    const exceedsPopoverElement = document.getElementById('exceedsPopoverClose-' + product?.materialNum + '-' + monthIndex + '-' + indx);
                    if (exceedsPopoverElement) {
                      exceedsPopoverElement.click();    //closes popover
                    }
                    week['showpopover'] = false;
                    week['thresholdError'] = false;
                    product['thresholdErrorCounter'] -= 1;
                    this.ref.detectChanges();
                  }
                });

                this.ref.detectChanges();
              }
            }
          });

          if (product['totalUnitsCount'] >= 0) {
            product['quantity'] = product['productQuantityValue'];
            product['quantity'] = product['quantity'] - product['totalUnitsCount'];



          }
        }

        else {
          product?.materialSchedule?.map((item, index) => {
            if (index === monthIndex) {
              this.monthsList[index].totalUnits += item['totalMonthsUnitsCount'];
              this.monthsList[index].totalDoses = this.monthsList[index].totalUnits * product?.quantityPerUnit;
            }
          });
        }
        // calculating remaining total units/doses
        totalRemaingUnits += product['quantity'];
        totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
        //Updating counter as per each product qty
        if (product['quantity'] < 0) {
          // totalNegativeQtyCounter +=1;
          this.totalNegativeQtyCounter += 1;
        }
      });

      const sumValues = { totalUnitsSum: 0, thresholdCounterSum: 0 };
      const thresholdAndTotalSum = this.stsProductsJoinedList.reduce((accumulator, currentObj) => {
        return {
          totalUnitsSum: accumulator.totalUnitsSum + currentObj.totalUnitsCount,
          thresholdCounterSum: accumulator.thresholdCounterSum + currentObj.thresholdErrorCounter,
        }
      }, sumValues);
      if (thresholdAndTotalSum?.thresholdCounterSum > 0) {
        this.thresholdError = true;
      }
      else {
        this.thresholdError = false;
      }











      if (this.totalNegativeQtyCounter === 0) {
        if (totalRemaingUnits === 0) { //all products scheduled
          this.schedulerStatus = 'All units and doses have been scheduled';
          this.remainingUnits = 0;
          this.remainingDoses = 0;
        }
        else if (totalRemaingUnits > 0) {
          this.schedulerStatus = 'Remaining to schedule';
          this.remainingUnits = totalRemaingUnits;
          this.remainingDoses = totalRemaningDoses;
        }
      }
      //case b - atleast 1 product exceeding
      else if (this.totalNegativeQtyCounter > 0) {
        this.schedulerStatus = 'Exceeds Total';
        totalRemaingUnits = 0;
        totalRemaningDoses = 0;
        //sum of all negative values only becomes total and doses
        //Will have to check later if below can be done without extra map method
        this.stsProductsJoinedList?.map((product) => {
          if (product['quantity'] < 0) {
            totalRemaingUnits += product['quantity'];
            totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
          }
        });
        this.remainingUnits = totalRemaingUnits;
        this.remainingDoses = totalRemaningDoses;
      }




      if (this.schedulerStatus === 'Exceeds Total' || thresholdAndTotalSum?.totalUnitsSum === 0) {
        this.isCalendarUpdated = false;
      }
      else {
        this.isCalendarUpdated = true;
      }
      this.ref.detectChanges();

















    }
  }

  togglePopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
    }
    if (this.currentPopover.isOpen()) {
      this.currentPopover.close();
    } else {
      this.currentPopover.open();
    }
  }

  closePopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
      if (this.currentPopover.isOpen()) {
        this.currentPopover.close();
      }
    }
  }
  openPopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
      if (!this.currentPopover.isOpen()) {
        this.currentPopover.open();
      }
    }
  }

  frequencyChange(event: any, stsProdData) {
    //need to see if passed parameters need to be used or not

    stsProdData['freqChanged'] = true;

    if (event !== 'reset') {
      const resetFreq = stsProdData?.frequencyList?.find(freq => freq.code === 'reset');
      if (!resetFreq) {
        stsProdData?.frequencyList?.push({
          code: 'reset',
          name: 'Reset'
        });
      }
    }
    this.updateFreqFlag = true;
    this.ref.detectChanges();
  }

  updateCalendar() {
    if (this.updateFreqFlag) {
      let stsFrequency = [];
      //loop through list, prepare the req
      this.stsProductsJoinedList.map(product => {
        //reset to be considered or not - need to check (reset considered and sent in request)
        if (product.selectedFreq && product.selectedFreq !== 'custom' && product.freqChanged) { //request to be sent only for product whose dropdown was changed
          let obj = {
            "productCode": product?.materialNum,
            "selectedFrequency": product.selectedFreq,
            "startDate": this.startDate,
            "endDate": this.endDate
          }
          stsFrequency?.push(obj);
        }
      });
      let finalReqBody = {
        "stsFrequencyUpdate": stsFrequency
      }

      let editFrequencyApi;
      if (this.editReservation) {
        editFrequencyApi = this.influenzaService.updateOrderStsFrequencyCalendarSectionData(this.userData.uid, this.parentCartId, this.activeSeasonId, this.b2bunitID, finalReqBody, this.reservationNo);
      }
      else {
        editFrequencyApi = this.influenzaService.updateStsFrequencyCalendarSectionData(this.userData.uid, this.parentCartId, this.activeSeasonId, this.b2bunitID, finalReqBody);
      }

      //this.influenzaService.updateStsFrequencyCalendarSectionData(this.userData.uid,this.parentCartId,this.activeSeasonId,this.b2bunitID,finalReqBody).subscribe(res=>{
      this.editFreqSub = editFrequencyApi.subscribe(res => {
        if (res && res !== null) {
          //update the details in the stsProductsJoinedList.
          //total units and total doses for each month to be recaculated based on api response. so setting previous values to 0
          this.monthsList?.map(month => {
            month.totalUnits = 0;
            month.totalDoses = 0;
          });
          //Need to recalculate Total remaining units/doses
          // let totalNegativeQtyCounter = 0;
          this.totalNegativeQtyCounter = 0;
          let totalRemaingUnits = 0;
          let totalRemaningDoses = 0;

          this.stsProductsJoinedList?.map(stsProd => {
            const matchedElement = res?.reservationSTSData?.find(entry => entry?.materialNum === stsProd?.materialNum);
            if (matchedElement) {

              stsProd['totalUnitsCount'] = 0;

              stsProd['thresholdErrorCounter'] = 0;

              stsProd?.materialSchedule?.map(existingMaterial => {
                const matchedSchedule = matchedElement?.materialSchedule?.find(newMaterial => newMaterial?.stsMonthYear === existingMaterial?.stsMonthYear);

                if (matchedSchedule) {


                  existingMaterial.maxThresholdAllowed = matchedSchedule?.maxThresholdAllowed;
                  existingMaterial.remThres = matchedSchedule?.remThres;
                  existingMaterial.sameAsPreviousSeason = matchedSchedule?.sameAsPreviousSeason;
                  existingMaterial.unassignedThres = matchedSchedule?.unassignedThres;







                  matchedSchedule?.weekList?.sort((a, b) => {
                    const dateA = new Date(a.startMonday);
                    const dateB = new Date(b.startMonday);
                    return dateA.getTime() - dateB.getTime();
                  });
                  existingMaterial.weekList = [...matchedSchedule?.weekList];

                  //1. recalculating totalMonthsUnitsCount for the month for that product
                  existingMaterial.totalMonthsUnitsCount = 0;
                  existingMaterial.weekList.map(week => {
                    if (week.finalQty > 0) {
                      existingMaterial.totalMonthsUnitsCount += week?.finalQty;
                    }
                  });

                  //2. update monthsList total units and total doses based on new data
                  let matchedMonth = this.monthsList?.find(month => month.monthyear === existingMaterial?.stsMonthYear);
                  if (matchedMonth) {
                    matchedMonth.totalUnits += existingMaterial['totalMonthsUnitsCount'];
                    matchedMonth.totalDoses = matchedMonth.totalUnits * stsProd['quantityPerUnit'];
                  }
                  //3. recalculate totalUnitsCount for the product
                  stsProd['totalUnitsCount'] += existingMaterial['totalMonthsUnitsCount'];
                }
              }); //materialSchedule loop ends
              //4. recalculate quantity for the product
              if (stsProd['totalUnitsCount'] >= 0) {
                stsProd['quantity'] = stsProd['productQuantityValue'];
                stsProd['quantity'] = stsProd['quantity'] - stsProd['totalUnitsCount'];
              }
            }
            else {//For other products whose freq not changed - totalMonthsUnitsCount/totalUnitsCount remain same as before
              stsProd?.materialSchedule?.map((existingMaterial) => {
                let matchedMonth = this.monthsList?.find(month => month.monthyear === existingMaterial?.stsMonthYear);
                if (matchedMonth) {
                  matchedMonth.totalUnits += existingMaterial['totalMonthsUnitsCount'];
                  matchedMonth.totalDoses = matchedMonth.totalUnits * stsProd['quantityPerUnit'];
                }
              });
            }

            totalRemaingUnits += stsProd['quantity'];
            totalRemaningDoses += stsProd['quantity'] * stsProd.quantityPerUnit;

            if (stsProd['quantity'] < 0) {

              this.totalNegativeQtyCounter += 1;
            }

            if (stsProd.selectedFreq === 'reset') {

              stsProd.frequencyList = stsProd?.frequencyList?.filter(freq => freq.code !== 'reset' && freq.code !== 'custom');
              stsProd.selectedFreq = undefined; //setting selected freq to none
            }
            else {

              const customFreq = stsProd?.frequencyList?.find(freq => freq.code === 'custom');
              if (customFreq) {
                stsProd.frequencyList = stsProd?.frequencyList?.filter(freq => freq.code !== 'custom');
              }
            }

            stsProd['prevSelectedFreq'] = stsProd['selectedFreq'];
            stsProd['prevFrequencyList'] = [...stsProd.frequencyList];
            stsProd['freqChanged'] = false;
          }); //prod loop ends


          const sumValues = { totalUnitsSum: 0, thresholdCounterSum: 0 };
          const thresholdAndTotalSum = this.stsProductsJoinedList.reduce((accumulator, currentObj) => {
            return {
              totalUnitsSum: accumulator.totalUnitsSum + currentObj.totalUnitsCount,
              thresholdCounterSum: accumulator.thresholdCounterSum + currentObj.thresholdErrorCounter,
            }
          }, sumValues);

          if (thresholdAndTotalSum?.thresholdCounterSum > 0) {
            this.thresholdError = true;
          }
          else {
            this.thresholdError = false;
          }











          if (this.totalNegativeQtyCounter === 0) {
            if (totalRemaingUnits === 0) { //all products scheduled
              this.schedulerStatus = 'All units and doses have been scheduled';
              this.remainingUnits = 0;
              this.remainingDoses = 0;
            }
            else if (totalRemaingUnits > 0) {
              this.schedulerStatus = 'Remaining to schedule';
              this.remainingUnits = totalRemaingUnits;
              this.remainingDoses = totalRemaningDoses;
            }
          }


          else if (this.totalNegativeQtyCounter > 0) {
            this.schedulerStatus = 'Exceeds Total';
            totalRemaingUnits = 0;
            totalRemaningDoses = 0;


            this.stsProductsJoinedList?.map((product) => {
              if (product['quantity'] < 0) {
                totalRemaingUnits += product['quantity'];
                totalRemaningDoses += product['quantity'] * product.quantityPerUnit;
              }
            });
            this.remainingUnits = totalRemaingUnits;
            this.remainingDoses = totalRemaningDoses;
          }



          if (this.schedulerStatus === 'Exceeds Total' || thresholdAndTotalSum?.totalUnitsSum === 0) {
            this.isCalendarUpdated = false;
          }
          else {
            this.isCalendarUpdated = true;
          }
          this.ref.detectChanges();
        } //if res ends
      },
        errors => {
          window.scrollTo(0, 0);
          this.globalMessage.add(errors.message, GlobalMessageType.MSG_TYPE_ERROR);
        }); //api res ends
      this.updateFreqFlag = false;
      this.ref.detectChanges();
    } //updateFreqFlag if ends
  }

  cancelUpdateCalendar() {
    //reverting back the frequency list and selected freq

    this.stsProductsJoinedList?.map((stsProd) => {
      if (stsProd['freqChanged']) {
        stsProd['selectedFreq'] = stsProd['prevSelectedFreq'];
        stsProd['frequencyList'] = [...stsProd.prevFrequencyList];
        stsProd['freqChanged'] = false;
      }
    });

    this.updateFreqFlag = false;
    //need to revert back the dropdown value as before
    this.ref.detectChanges();
  }


  //Not used
  getMonthsAndWeeks(startDateStr: string, endDateStr: string) {
    const startDate = new Date(startDateStr?.split("T")[0]);
    const endDate = new Date(endDateStr?.split("T")[0]);

    this.monthsList = [];
    this.weeksList = [];

    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = currentDate.toLocaleString('default', { month: 'long' });

      const reqMonth = `${month} ${year}`
      const matchedMonth = this.monthsList?.find(item => item === reqMonth);
      if (!matchedMonth) {
        this.monthsList.push(reqMonth);
      }

      // Find the start of the current week (Monday)
      currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1);

      // Generate week string in MM/DD/YYYY format
      const weekStr = `${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getDate().toString().padStart(2, '0')}/${year}`;
      this.weeksList.push(weekStr);

      // Move to the next week
      currentDate.setDate(currentDate.getDate() + 7);
    }

    this.grouped_items = _.groupBy(this.weeksList, (b) =>
      moment(b).startOf('month').format('YYYY/MM'));
    _.values(this.grouped_items)
      .forEach(arr => arr.sort((a, b) => moment(a).day() - moment(b).day()));
  }
























  transformWeek(week) {
    if (week && week != null) {
      const parts = week?.split('/');
      if (parts?.length === 3) {
        return `${parts[0]}/${parts[1]}`;
      }
      else {
        return week;
      }
    }
  }

  getFrequencyDropdown() {
    this.frequencyList = [{
      name: 'Weekly',
      code: 'Onceperweek'
    },
    {
      name: 'Monthly',
      code: 'Oncepermonth'
    },
    {
      name: 'Twice a month',
      code: 'Twicepermonth'
    },
    ];
  }


  saveAndContinue() {
    //call save api and redirect to checkout on success.
    let stsData = [];
    //set stsProductsJoinedList in session - Needed in case of edit doses (to get previous finalqty set if any - not sure if can use from session and user might change data in select vaccine)
    this.sharedService.setSessionStorage('stsRequestData', this.stsProductsJoinedList);
    this.stsProductsJoinedList.map(product => {
      let obj = {
        "materialNum": product?.materialNum,
        "materialSchedule": product?.materialSchedule
      }
      stsData?.push(obj);
    });
    let finalReqBody = {
      "reservationSTSData": stsData
    }

    let saveStsApi;
    if (this.editReservation) {
      saveStsApi = this.influenzaService.updateStsOrder(this.userData.uid, this.parentCartId, this.activeSeasonId, this.b2bunitID, finalReqBody, this.reservationNo);
    }
    else {
      saveStsApi = this.influenzaService.saveStsOrder(this.userData.uid, this.parentCartId, this.activeSeasonId, this.b2bunitID, finalReqBody);
    }

    this.saveStsSub = saveStsApi.subscribe(res => {
      if (res && res !== null) {

        this.sharedService.setSessionStorage('stsResponseData', res);
        this.redirectToCheckout('saveAndContinue');
      }
    }, errors => {
      window.scrollTo(0, 0);
      this.globalMessage.add(errors.message, GlobalMessageType.MSG_TYPE_ERROR);
    });
  }
  scheduleLater(content) {
    if (this.isCalendarUpdated) {
      this.modalService.open(content, {
        centered: true,
        backdrop: 'static',
        windowClass: `scheduleLterModal ${this.baseSiteId}`
      });
    }
    else {
      this.redirectToCheckout('scheduleLater');
    }
  }

  redirectToCheckout(action?) {
    let verifyUrl = '/FluverifypaymentPage?';  //for schedule later case (normal case without sts)
    if (action === 'saveAndContinue') {
      verifyUrl = '/FluverifypaymentPage?stsSchedule=yes&';
    }
    if (this.editReservation) {
      this.router.goByUrl(verifyUrl + 'editReservation=yes&orderNo=' + this.reservationNo + '&deliveryDate=' + this.deliveryDate +'&shippingDate=' +this.shipDate);
    } else {
      this.router.goByUrl(verifyUrl + 'deliveryDate=' + this.deliveryDate +'&shippingDate=' +this.shipDate);
    }
  }

  closePopup() {
    this.modalService.dismissAll();
  }

  continueRequest() {
    this.isUpdated = false;
    if (this.nextRouteUrl === '') { //will be blank only influenza dashboard

      this.router.goByUrl('influenza/dashboard?fromFlu=yes');
    }
    else {
      this.router.goByUrl(this.nextRouteUrl); //or use angular router if doesnt work
    }
    this.closePopup();
  }

  backToDashBoard(content, booleanFlag) {
    if (booleanFlag) {
      this.modalService.open(content, {
        centered: booleanFlag,
        backdrop: 'static',
        windowClass: `confirmLeaveModal ${this.baseSiteId}`
      });
    }
    else {

      this.router.goByUrl('influenza/dashboard?fromFlu=yes');
    }
  }
  downloadExcel() {
    let jsonArrayData = [];
    for (let prod of this.stsProductsJoinedList) {
      let jsonObj = {}
      jsonObj['Customer'] = this.b2bunitID;
      jsonObj['Material'] = prod?.materialNum;
      jsonObj['Frequency'] = prod?.selectedFreq ? prod?.selectedFreq : 'No frequency selected';
      jsonObj['Units/Doses'] = prod?.totalUnitsCount + '/' + prod?.totalUnitsCount * prod?.quantityPerUnit;

      jsonArrayData.push(jsonObj);
    }
    this.addToCart.downloadXls(jsonArrayData, 'STS_details');
  }

  downloadExcelNew() {

    let arrayOfHeadings = ['Customer', '', 'Material', 'Frequency', 'Total Units/Doses'];
    let arrayOfMaterials = [];
    this.stsProductsJoinedList.map((stsProd, index) => {
      let materialArr = [];
      if (index === 0) {
        materialArr.push(this.b2bunitID);
      }
      else {
        materialArr.push('');
      }

      materialArr.push('Requested Quantity');
      materialArr.push(stsProd?.materialNum);
      let selectedFreq = stsProd?.selectedFreq ? stsProd?.selectedFreq : 'No frequency selected';
      materialArr.push(selectedFreq);

      let totalUnitsDoses = stsProd?.productQuantityValue + '/' + stsProd?.productQuantityValue * stsProd?.quantityPerUnit;
      materialArr.push(totalUnitsDoses);

      stsProd?.materialSchedule?.map((item, indx) => {
        if (index === 0) {   //headings array can be created using 1st product
          arrayOfHeadings.push('');
          arrayOfHeadings.push(item?.stsMonthYear);
        }
        materialArr.push('');
        materialArr.push('');

        item?.weekList?.map(week => {
          if (index === 0) {
            const weekDate = this.transformWeek(week?.startMonday);
            arrayOfHeadings.push(weekDate);
          }

          let weekUnitDoses = week?.finalQty + '/' + week?.finalQty * stsProd?.quantityPerUnit;
          materialArr.push(weekUnitDoses);
        });
        materialArr.push(''); //empty for total monthly count for product. Total monthly count is added to last column
        if (index === 0) {
          arrayOfHeadings.push('Total Units/Doses');
        }
      });
      arrayOfMaterials.push(materialArr);
    });

    //Added to have another column for total monthly count at last column
    this.stsProductsJoinedList.map((stsProd, index) => {
      let materialArr = [];
      if (index === 0) {
        materialArr.push('', '', '', '', '');
        stsProd?.materialSchedule?.map((item, indx) => {
          materialArr.push('', '');
          item?.weekList?.map(week => {
            materialArr.push('');
          });
          let monthUnitDoses = this.monthsList[indx].totalUnits + '/' + this.monthsList[indx].totalDoses;
          materialArr.push(monthUnitDoses);
        });
        arrayOfMaterials.push(materialArr);
      }
    });
    let fileName = 'STS_details';
    if (this.editReservation) {
      fileName = fileName + '_' + this.reservationNo;
    }

    this.generateExcelFile(arrayOfHeadings, arrayOfMaterials, fileName);
  }


  generateExcelFile(arrayOfHeadings: any[], arrayOfMaterials: any[], fileName: string): void {
    let arrayOfMonths = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
    // new workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // new worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([]);

    const maxArrayLength = arrayOfHeadings.length; // no of rows

    // Loop through the arrays and add data to the worksheet column by column
    for (let i = 0; i < maxArrayLength; i++) {
      const rowData = [];
      rowData.push(arrayOfHeadings[i] || '');
      arrayOfMaterials.forEach(materialArr => {
        rowData.push(materialArr[i]);
      });
      // Add the data to the worksheet
      XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: `A${i + 1}` });

      //Making Months bold
      if (arrayOfHeadings[i] !== '') {
        const parts = arrayOfHeadings[i]?.split(' ');
        if (parts?.length > 0) {
          const heading = parts[0];
          if (arrayOfMonths?.includes(heading?.toLowerCase())) {
            for (let col = 0; col < rowData.length; col++) {
              const cellAddress = XLSX.utils.encode_cell({ r: i, c: col });
              ws[cellAddress].s = {};
              ws[cellAddress].s.font = {};
              ws[cellAddress].s.font.bold = true;
            }
          }
        }
      }
    }

    //setting fixed width for each column
    let noOfColumns = arrayOfMaterials?.length + 1;
    ws['!cols'] = Array(noOfColumns).fill({ width: 15 })

    //worksheet added to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'STS_details');

    //blob containing the Excel file data
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName, true);
  }

  saveAsExcelFile(buffer: any, fileName: string, filename_change_not_needed?: boolean): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    if (!!filename_change_not_needed) {
      FileSaver.saveAs(
        data,
        fileName + EXCEL_EXTENSION
      );
    } else {
      FileSaver.saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    }
  }

  OnPrint() {
    window.print();
  }

  setSeasonId() {
    const seasonID = this.sharedService.getSessionStorage('activeSeasons');
    if (seasonID) {
      this.activeSeasonId = seasonID;
    }
    else {
      this.activeSeasonSubscriber = this.influenzaService.activeSeaons.subscribe((response) => {
        if (response) {
          response?.categoryData?.forEach((season) => {
            if (season['defaultSeason']) {
              this.activeSeasonId = season['code'];
            }
          });
          if (this.activeSeasonId === undefined || this.activeSeasonId === null) {
            this.activeSeasonId = response?.categoryData?.[0]?.code;    //assigning 1st index as the last resort
          }
          this.activeSeasonSubscriber?.unsubscribe();
          this.ref.detectChanges();
        }
      });
    }
  }

  numberCheck(event) {
    const charCode = event.which ? event.which : event.keyCode;
    let inputValue = (event?.target as HTMLInputElement)?.value;
    if (inputValue?.length > 3) {
      return false;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkBlank(event) {
    let inputValue = (event.target as HTMLInputElement).value;
    if (inputValue === '') {
      (event.target as HTMLInputElement).value = '0';
    }
  }

  getB2BUid() {
    let b2bUid: string;
    if ('selectedLocations' in sessionStorage) {
      b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber;
    }
    else {

      b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0].accountNumber;
    }
    return b2bUid;
  }
  getCartsApi(userName) {

    this.influenzaService.getCarts(userName);
    this.getCartsApiSubscriber = this.influenzaService.cartItems.subscribe((res) => {

      if (res) {



        let requiredCart = res?.carts?.find((item) => item?.childCarts?.length > 0);
        this.parentCartId = requiredCart?.code;
        let childCartDtls = requiredCart?.childCarts;


        this.getShippingCompleteData(userName, this.parentCartId, this.activeSeasonId, this.b2bunitID);
      }
    });
  }

  checkForEditReservation() {
    this.editReservation = this.activatedRoute.snapshot.queryParams.editReservation ? true : false;
    this.cancelSts = this.activatedRoute.snapshot.queryParams.cancelSts ? true : false;
    this.reservationNo = this.activatedRoute.snapshot.queryParams.orderNo ? this.activatedRoute.snapshot.queryParams.orderNo : '';
    if (this.editReservation) {						//if condition added
      this.isCalendarUpdated = true;
      this.reservationStatus = this.sharedService.getSessionStorage('reservationStatus');
      this.notConfirmedMessage = this.sharedService.getSessionStorage('alertMessage');
      this.checkFluTimerCompletion();
    }
    this.ref.detectChanges();
  }

  showClearCalendarPopup() {
    this.modalService.open(this.clearCalendarContent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: `clearCalendrModal ${this.baseSiteId}`
    });
  }

  editDoses() {
    this.sharedService.setSessionStorage('isEditFlu', true);
    if (this.editReservation) {
      this.router.goByUrl('/fluCategoryPage?editReservation=yes&cancelSts=yes&orderNo=' + this.reservationNo);
    }
    else {
      this.router.goByUrl('fluCategoryPage');
    }

  }
  //will be called only in case of cancel sts
  clearCalendar() {
    //make qty as 0 for all products and call save api and redirect to checkout on success.
    let stsData = [];
    this.sharedService.setSessionStorage('stsRequestData', this.stsProductsJoinedList);
    this.stsProductsJoinedList.map(product => {
      //make final qty of all products as zero & then add to obj
      product?.materialSchedule?.map((item) => {
        item['monthThreshold'] = 0;
        item['totalMonthsUnitsCount'] = 0;
        item?.weekList?.map((week) => {
          if (week?.finalQty > 0) {
            week.finalQty = 0;
          }
        });
      });
      let obj = {
        "materialNum": product?.materialNum,
        "materialSchedule": product?.materialSchedule
      }
      stsData?.push(obj);
    });

    let finalReqBody = {
      "reservationSTSData": stsData
    }
    let saveStsApi;
    if (this.editReservation) {
      saveStsApi = this.influenzaService.updateStsOrder(this.userData.uid, this.parentCartId, this.activeSeasonId, this.b2bunitID, finalReqBody, this.reservationNo);
    }
    else {
      saveStsApi = this.influenzaService.saveStsOrder(this.userData.uid, this.parentCartId, this.activeSeasonId, this.b2bunitID, finalReqBody);
    }
    this.saveStsSub = saveStsApi.subscribe(res => {
      if (res && res !== null) {
        //on success response -> redirect and also save the response in the session to be passed in place order api.
        this.sharedService.setSessionStorage('stsResponseData', res);
        this.redirectToCheckout('saveAndContinue');
      }
    }, errors => {
      window.scrollTo(0, 0);
      this.globalMessage.add(errors.message, GlobalMessageType.MSG_TYPE_ERROR);
    });

  }

  checkFluTimerCompletion() {
    this.fluTimerJourneySub = this.influenzaService.fluTimerCompletedSubject.subscribe((res) => {
      if (res) {
        this.showFluExtendPopup();
      }
    })
  }
  showFluExtendPopup() {
    const modalRef = this.modalService.open(GeneralPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `fluLockExtendModal ${this.baseSiteId}`
    });
    modalRef.componentInstance.popup_title = 'Influenza Session Expiry';
    modalRef.componentInstance.popup_content = 'Your Influenza session is about to expire.<br />Do you want to continue on Influenza page?';
    modalRef.componentInstance.continueCancelButtons = true;
    this.FluExtendSub = modalRef.componentInstance.extendOrCancelEvent.subscribe((res) => {

      if (res === 'extend') {
        this.extendLock();
        this.influenzaService.extendFluJourneyTimer(this.fluTimer);
      }
      else {

        this.router.goByUrl('influenza/dashboard?fromFlu=yes'); //lock will be released on checkNavigationAway
      }
    });
  }

  extendLock() {
    const params = {
      "requstType": 'EXTENDLOCK',    //UNLOCK to unlock
      "orderNumber": this.reservationNo  //this.reservationNo sample - 1092000246
    }

    this.influenzaService.fluLockOrUnlock(this.userData.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessageNo = res.messageNumber;

          if (lockStatus === 'S' && lockMessageNo === '003') {

          }
          else {

          }
        }
      }, errors => {

      })
  }


  releaseLock() {
    const params = {
      "requstType": 'UNLOCK',    //UNLOCK to unlock
      "orderNumber": this.reservationNo  //this.reservationNo sample - 1092000246
    }
    this.influenzaService.fluLockOrUnlock(this.userData.userName, params)
      .pipe(take(1))
      .subscribe(res => {
        if (res !== null || res !== undefined) {
          const lockStatus = res.mssageType;
          const lockMessage = res.message;
          const lockMessageNo = res.messageNumber;

          if (lockStatus === 'S' && lockMessageNo === '002') {
            this.influenzaService.endFluJourneyTimer();
          }



        }
      }, errors => {

      });
  }


  checkNavigationAway() {
    this.navigationEndSub = this.route.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const nextRoute = event.url; //next route URL
          if (this.isUpdated) {
            if (nextRoute?.includes('fluCategoryPage')
              || nextRoute?.includes('FluverifypaymentPage')
              || nextRoute?.includes('fluStsLandingPage')) { //add more urls if required.
              //no action needed & dont release lock
              //may need to remove influenza dashboard from here.
              if (this.editReservation && nextRoute?.includes('influenza/dashboard')) {
                this.releaseLock();
                if (this.parentCartId) {
                  this.addToCart.clearCartWithoutReload(this.parentCartId);
                }
              }
            }
            else {
              //stop navigation and show popup
              this.route.navigate([], { skipLocationChange: true });
              this.nextRouteUrl = nextRoute;
              this.modalService.open(this.modalContent, {
                centered: true,
                backdrop: 'static',
                windowClass: `confirmLeaveModal ${this.baseSiteId}`
              });

            }
          }
          else {

            if (this.editReservation) {
              this.releaseLock();
              if (this.parentCartId) {
                this.addToCart.clearCartWithoutReload(this.parentCartId);
              }
            }
            else {
              if (this.parentCartId) {
                this.addToCart.clearCartWithoutReload(this.parentCartId);
              }
            }
          }
        }
      });
  }

  checkLogout() {
    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        if (this.editReservation) {
          this.releaseLock();//AccessDeniedError might come at this time
          this.influenzaService.endFluJourneyTimer();
        }
        this.authCheckSub = this.authService.isUserLoggedIn().subscribe((res2) => {
          if (!res2) {
            this.sharedService.removeSessionStorage('fluData');
            this.sharedService.removeSessionStorage('estimateData');
            this.sharedService.removeSessionStorage('isEditFlu');
            this.sharedService.removeSessionStorage('contractPrices');
            this.sharedService.removeSessionStorage('tempoData');
            this.sharedService.removeSessionStorage('tempoDataInv');
            this.authCheckSub?.unsubscribe();
          }
        });
      }
    });
  }

  productDetails(productDetails, i): void {
    const modalRef = this.modalService.open(ProductDetailsInfluenzaComponent, {
      windowClass: `product-details-inf-modal ${this.baseSiteId}`
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = productDetails.code;
  }

  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.getCartsApiSubscriber?.unsubscribe();
    this.navigationEndSub?.unsubscribe();
    this.fluTimerJourneySub?.unsubscribe();
    this.FluExtendSub?.unsubscribe();
    this.editFreqSub?.unsubscribe();
    this.saveStsSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
}
